// Base configuration for content
const baseProfileContent = {
  type: "image",
  inputType: "",
  label: "",
  data: {
    id: "",
    key: "",
    value: "",
    type: "profile",
    file: {},
    isUpdated: false,
  },
  translation: {
    id: "",
    name: "",
    translationableId: "",
    translationableType: "Resource",
    adminId: "",
    languageId: "",
    flag: true,
    isUpdated: false,
  },
};

// Factory function to create a profile entry
const createProfileEntry = (title: string, key: string) => ({
  title,
  content: {
    ...baseProfileContent,
    data: {
      ...baseProfileContent.data,
      key,
    },
    translation: {
      ...baseProfileContent.translation,
    },
  },
  isRequired: false,
  readonly: false,
  isButton: true,
});

// Array of profile entries
const profileEntries = [
  { title: "Play", key: "play" },
  { title: "Points", key: "points" },
  { title: "Shares", key: "shares" },
  { title: "Club", key: "club" },
  { title: "Contact", key: "contact" },
  { title: "Result", key: "result" },
];

// Map the profile entries to create the profile array
const profile = profileEntries.map(({ title, key }) => createProfileEntry(title, key));

export { profile };
